/* import __COLOCATED_TEMPLATE__ from './fin-offer-unavailable-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type RouterService from '@ember/routing/router-service';

export interface Args {
  openModal: boolean;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class FinOfferUnavailableModal extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;
  @tracked isOpen = this.args.openModal;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (this.args.openModal) {
      this.trackAnalyticsEvent({
        action: 'viewed',
        object: 'fin_offer_unavailable_modal',
        place: 'fin_offer_unavailable_modal',
      });
    }
  }

  @action
  closeModal() {
    this.trackAnalyticsEvent({
      action: 'clicked',
      object: 'close_fin_offer_unavailable_modal',
      place: 'fin_offer_unavailable_modal',
    });
    this.isOpen = false;

    this.clearFinOfferQueryParam();
  }

  @action
  acknowledgeUnavailableOffer() {
    this.trackAnalyticsEvent({
      action: 'clicked',
      object: 'acknowledge_button',
      place: 'fin_offer_unavailable_modal',
    });
    this.isOpen = false;
    this.clearFinOfferQueryParam();
  }

  private trackAnalyticsEvent(eventData: Record<string, string>) {
    this.intercomEventService.trackAnalyticsEvent(eventData);
  }

  private clearFinOfferQueryParam() {
    let currentQueryParams = { ...this.router.currentRoute.queryParams };
    delete currentQueryParams.finOffer;

    this.router.transitionTo(this.router.currentRouteName, { queryParams: currentQueryParams });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::FinOfferUnavailableModal': typeof FinOfferUnavailableModal;
    'incentive-offer/fin-offer-unavailable-modal': typeof FinOfferUnavailableModal;
  }
}
